import { escapeRegExp } from 'lodash-es';
import { InputRule } from 'prosemirror-inputrules';
import { EditorState } from 'prosemirror-state';
import { EmojiPlugin } from '../plugins/EmojiPlugin/EmojiPlugin';
import { EmojiMenuStore } from '../plugins/EmojiPlugin/store';
import { Extension } from './base/Extension';

const emojiRegex = new RegExp(
  `(?:^|\\s|\\()${escapeRegExp(':')}(${'[\\p{L}/\\p{M}\\d\\s{1}\\.\\-–_]+'})?$`,
  'u'
);

export class EmojiMenuTrigger extends Extension {
  constructor(private readonly state: EmojiMenuStore) {
    super('emoji-menu-trigger');
  }

  plugins() {
    return [new EmojiPlugin(emojiRegex, this.state)];
  }

  inputRules() {
    return [
      new InputRule(emojiRegex, (state: EditorState, match: RegExpMatchArray) => {
        const { parent } = state.selection.$from;

        if (match && parent.type.name === 'paragraph') {
          if (match[0].length) {
            this.state.setOpen(true);
          } else {
            this.state.setOpen(false);
          }
          this.state.setQuery(match[1]);
        }

        return null;
      }),
    ];
  }
}
